





































































import { Vue, Component, Prop } from "vue-property-decorator";
import { CourseUnion as ICourse } from "@/api/models/course-union";
import {
  isRoot,
  getCurrentCompanyId,
  getCurrentEmployee
} from "@/plugins/roles";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
@Component({
  components: { CustomTableCol, CustomTableItem }
})
export default class CourseListItemTables extends Vue {
  @Prop() course!: ICourse;

  data() {
    return {
      coursesList: undefined
    };
  }

  get selectedCompanyId() {
    return this.$store.getters.selectedCompany.id;
  }

  get showActions() {
    return this.root || this.companyOwner || this.contentManager;
  }

  get editRoute() {
    //@ts-ignore
    const version = this.course?.version;
    let pathParams;
    if (version === "v1") {
      pathParams = { name: "courseEdit", params: { courseId: this.course.id } };
    } else {
      pathParams = { name: "courseEditV2", params: { id: this.course.id } };
    }

    return pathParams;
  }

  get routePathToCourse() {
    //@ts-ignore
    const version = this.course?.version;
    let pathParams;
    if (version === "v1") {
      pathParams = { name: "courseView", params: { courseId: this.course.id } };
    } else {
      pathParams = { name: "course", params: { id: this.course.id } };
    }

    return pathParams;
  }

  get screenWidth() {
    return window.innerWidth;
  }

  get root() {
    return isRoot();
  }

  get learningRequestManager() {
    return this.$store.getters.roles.includes("learning_request_manager");
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get companyId(): string {
    return getCurrentCompanyId();
  }

  get currentEmployee() {
    return getCurrentEmployee();
  }

  get documentManager() {
    return this.currentEmployee?.roles.includes("document_manager");
  }

  get contentManager() {
    return this.$store.getters.roles.includes("content_manager");
  }

  get canEditCourse() {
    return this.root || this.companyOwner || this.contentManager;
  }
}
